export default {
  'ean-code': (field, args) => `${field} ist falsch`,
  'greater-than': (field, minValue) => `Der Wert muss größer als ${minValue} sein`,
  'gsm-number': (field, args) => 'Die Nummer muss mit 4 beginnen und aus 9 Ziffern bestehen',
  'index-value': (field, args) => 'Ihr Zählerstand darf nur Zahlen beinhalten. Bitte überprüfen Sie den eingegebenen Wert',
  'landline-number': (field, args) => `Die Nummer darf nicht das Präfix Null enthalten und besteht aus 8 oder 9 Ziffern`,
  'max-digits': (field, maxDigits) => `Der Index kann maximal ${maxDigits} Ziffern enthalten`,
  'meter-number': (field, args) => `Die Nummer besteht aus den letzten 4 Ziffern Ihres Zählers`,
  'only-letters': (field, args) => `Bitte kodiere nur Buchstaben`,
  're-captcha': (field, args) => `Bitte vervollständigen Sie das Captcha. Dies ermöglicht eine zusätzliche Überprüfung gegen Malware.`,
  'reference-number': (field, args) => `${field} besteht aus 8 Ziffern`,
  'no-accents': (field, args) => `${field} darf keinen Akzent enthalten`,
  'no-special-chars-email': (field, args) => `${field} ist falsch`
}
